import React from 'react';

export const whatsappNumber = '919868510836';
export const whatsappMessage = 'Hello Zyvora Life Sciences 9, I would like to know more about your livestock nutrition products and dealership opportunities.';
export const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

function WhatsAppButton() {
  return (
    <a
      className="whatsapp-float"
      href={whatsappUrl}
      target="_blank"
      rel="noreferrer"
      aria-label="Send WhatsApp inquiry to Zyvora Life Sciences 9"
    >
      <span aria-hidden="true">✆</span>
      <strong>WhatsApp Inquiry</strong>
    </a>
  );
}

export default WhatsAppButton;
